module.exports = __webpack_public_path__ + "static/media/act.a5f88848.webp";